module.exports = __webpack_public_path__ + "img/Snakeater.8c16e31f.png";